import React from 'react'
import InputCustom from 'components/Inputs'
import { FiTrash } from 'react-icons/fi'
import { RiIncreaseDecreaseLine } from 'react-icons/ri'
import { Col, Collapse, Row } from 'reactstrap'
import { SimpleTitleCard } from 'styles/global'
import CardParametrizacao from './CardParametrizacao'
import { BiChevronDown } from 'react-icons/bi'
import { useSelector } from 'react-redux'
import { ApplicationState } from 'store'
import { PRODUTO } from 'store/modules/backoffice/produto/types'
import { ParametrizacaoProdutoReq } from 'models/backoffice/produto/type'
import * as produtoActions from 'store/modules/backoffice/produto/actions'
import useRedux from 'hooks/useRedux'
import { maskMoney } from 'util/masks'

const CardSaldoDevedor = () => {
  const { register, visualizacao, cardsState, invalids } = useSelector<
    ApplicationState,
    PRODUTO
  >((state) => state.produto)

  const { dispatch } = useRedux()

  type Field = keyof ParametrizacaoProdutoReq

  function onChange(value: string | number, field: Field) {
    dispatch(produtoActions.setRegister({ ...register, [field]: value }))
  }

  function onToggle() {
    dispatch(
      produtoActions.toggleCard(!cardsState.saldoDevedor, 'saldoDevedor')
    )
  }

  return (
    <CardParametrizacao>
      <div className="d-flex justify-content-between">
        <SimpleTitleCard color="#000" colorIcon="#000">
          <RiIncreaseDecreaseLine className="icon" />
          Saldo devedor contrato original
        </SimpleTitleCard>
        <BiChevronDown onClick={() => onToggle()} className="toggler" />
      </div>
      <Collapse isOpen={cardsState.saldoDevedor}>
        <div className="d-flex flex-column row-gap-10">
          <Row>
            <Col md={4}>
              <label className="label-12">De: (em R$)</label>
              <InputCustom
                type="text"
                placeholder="Digite aqui"
                onChange={(e) => {
                  onChange(maskMoney(e.target.value), 'saldoDevedorMin')
                }}
                value={register.saldoDevedorMin || ''}
                disabled={visualizacao}
                maxLength={14}
                invalid={invalids.saldoDevedorMin}
              />
            </Col>
            <Col md={4}>
              <label className="label-12">Até: (em R$)</label>
              <InputCustom
                type="text"
                placeholder="Digite aqui"
                onChange={(e) => {
                  onChange(maskMoney(e.target.value), 'saldoDevedorMax')
                }}
                value={register.saldoDevedorMax || ''}
                disabled={visualizacao}
                maxLength={14}
                invalid={invalids.saldoDevedorMax}
              />
            </Col>
          </Row>
          <div className="linha-horizontal"></div>
          {!visualizacao && (
            <Row>
              <Col className="d-flex justify-content-end">
                <FiTrash
                  onClick={() => dispatch(produtoActions.cleanSaldoDevedor())}
                  className="icon-trash"
                />
              </Col>
            </Row>
          )}
        </div>
      </Collapse>
    </CardParametrizacao>
  )
}

export default CardSaldoDevedor
